import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Textarea } from '@televet/kibble-ui/build/components/Textarea';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { VStack } from '@televet/kibble-ui/build/chakra';
import { updateAppointmentDraft } from 'pages/Appointments/state/appointmentsModalSlice';
import { useAppDispatch, useAppSelector } from 'state/hooks';

export function AppointmentNotes(): JSX.Element {
  const [showNotes, setShowNotes] = useState(false);
  const { description } = useAppSelector((state) => state.appointmentsModal.appointmentDraft);
  const dispatch = useAppDispatch();

  const handleOnChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      dispatch(updateAppointmentDraft({ description: e.target.value }));
    },
    [dispatch],
  );

  const handleShowHideNotes = useCallback(() => {
    setShowNotes((prevState) => !prevState);

    if (showNotes) {
      dispatch(updateAppointmentDraft({ description: '' }));
    }
  }, [dispatch, showNotes]);

  useEffect(() => {
    if (!showNotes) {
      setShowNotes(!!description?.length);
    }
  }, [description?.length, showNotes]);

  return (
    <VStack className="AppointmentModal__Notes" w="100%" align="flex-start">
      {showNotes && (
        <Textarea
          value={description}
          onChange={handleOnChange}
          label="Appointment Notes"
          labelStyle={{ fontWeight: 'bold' }}
          data-testid="appointment-notes-textarea"
        />
      )}
      <Button
        onClick={handleShowHideNotes}
        variant={showNotes ? 'ghostDestructive' : 'ghost'}
        iconName={showNotes ? 'minus' : 'plus'}
        data-testid="appointment-notes-toggle-button"
      >
        {showNotes ? 'Remove' : 'Add'} Notes
      </Button>
    </VStack>
  );
}
